import PrimaryButton from '../../../../../components/button/PrimaryButton';
import Lottie from 'lottie-react';
import successLottie from '../../../../../styles/lottie/success.json';
import FidelityCardTile from '../../FidelityCardTile';
import { useEffect, useState } from 'react';
import useAxios
 from '../../../../../axios/useAxios';
import CustomLoader, { LoaderColor, LoaderSize } from '../../../../../components/loader/CustomLoader';
import { useSelector } from 'react-redux';
import { PikkoBulle } from './pikkoBulle';

const SUCCESS_TITLE = 'Bravo !';
const SUCCESS_EMOJI = '🎉';
const PRIMARY_MESSAGE = 'Ta nouvelle carte a été créée avec succès !';
const SECONDARY_MESSAGE = 'Tu peux désormais l\'utiliser lors de tes paiements avec Pikkopay';
const BUTTON_LABEL = 'Voir mes cartes';

const LOTTIE_CONFIG = {
  animationData: successLottie,
  loop: false,
  autoplay: true,
};


const SuccessAnimation = () => (
  <div className="w-32 h-32 mb-8">
    <Lottie {...LOTTIE_CONFIG} />
  </div>
);

const SuccessTitle = () => (
  <h2 className="text-3xl font-bold mb-6 geomanistBold bg-gradient-to-r from-green-500 to-green-700 bg-clip-text text-transparent">
    {SUCCESS_TITLE} <span>{SUCCESS_EMOJI}</span>
  </h2>
);

const SuccessMessage = () => (
  <div className="text-center mb-12">
    <p className="text-xl text-gray-700 mt-2 geomanistRegular">
      {SECONDARY_MESSAGE}
    </p>
  </div>
);

const ActionButton = ({ onConfirm }) => (
  <div className="w-full max-w-sm transform transition-transform mt-6">
    <PrimaryButton
      onClick={onConfirm}
      label={BUTTON_LABEL}
      className="w-full py-4 rounded-xl duration-300"
    />
  </div>
);

const SuccessScreen = ({ onConfirm }) => {
  const [fidCards, setFidCards] = useState(null);
  const axiosInstance = useAxios();
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector(state => state.user);

  useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get(`/user/${user._id}/fidelity-cards`)
      .then((response) => {
        setFidCards(response.data);
      })
      .catch((error) => {
        console.error({ error });
      })
      .finally(() => setIsLoading(false));
  }, []);


  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-gradient2 overflow-hidden">
      <div className="relative gap-4 z-10 flex flex-col items-center px-6 py-12 mx-auto max-w-lg">
        <SuccessAnimation />
        <SuccessTitle />
        <PikkoBulle message={PRIMARY_MESSAGE} />
        {isLoading ? (
          <div className="flex items-center justify-center">
            <CustomLoader loaderSize={LoaderSize.BIG} loaderColor={LoaderColor.GREY} />
          </div>
        ) : (
        fidCards && fidCards.map((fidCard) => (
          <FidelityCardTile
            onClick={() => {}}
            img={fidCard.cardImage}
            logo={fidCard.companyImage}
            name={fidCard?.fidelityInfo?.ficheClient?.nom}
            surname={fidCard?.fidelityInfo?.ficheClient?.prenom}
            numero={fidCard?.fidelityInfo?.ficheClient?.numeroCarte}
          />
        ))
        )}
        <SuccessMessage />
        <ActionButton onConfirm={onConfirm} />
      </div>
    </div>
  );
};

export default SuccessScreen;